export default "__VITE_ASSET__0b4fd078__"